import { IconButton, Tooltip, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { containerEntregaAguardandoRecebimento, IconReceber, sxGrid } from "./sxEntregaAguardandoRecebimento"
import { sxTypografy, sxTypografySemDest } from "../../ListaEntregas/Entregas/sxEntrega"
import { useState } from "react"
import ModalConfirmacaoChegouEntrega from "./ModalConfirmacaoChegouEntrega/ModalConfirmacaoChegouEntrega.jsx"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import InfoEntrega from "../../ListaEntregas/InfoEntrega/InfoEntrega.jsx"

const EntregaAguardandoRecebimento = ({ result }) => {
    const [openModalConfirmar, setOpenModalConfirmar] = useState(false)
    const [openModalInfo, setOpenModalInfo] = useState(false)

    const handleConfirmar = () => {
        setOpenModalConfirmar(true)
    }

    const handleInfo = () => {
        setOpenModalInfo(true)
    }

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={containerEntregaAguardandoRecebimento}>

            <Grid container xs={12} sm={12} md={5.5} lg={3.5} xl={5} sx={sxGrid}>
                <Grid xs={3} sm={3} md={3} lg={2} xl={2}>
                    <Typography sx={sxTypografy}>{result.id_encomenda}</Typography>
                </Grid>
                <Grid xs={3} sm={3} md={3} lg={2.5} xl={2}>
                    <Tooltip title='Receber encomenda' placement='bottom' arrow>
                        <IconButton sx={IconReceber} onClick={handleConfirmar}><CheckCircleOutlineIcon /></IconButton>
                    </Tooltip>
                </Grid>
                <Grid xs={6} sm={6} md={6} lg={7.5} xl={8}>
                    {
                        result.morador
                            ? <Typography sx={sxTypografy}>{result.morador}</Typography>
                            : <Typography sx={sxTypografySemDest}>SEM DESTINATÁRIO</Typography>
                    }
                </Grid>
            </Grid>

            <Grid xs={12} sm={12} md={2} lg={2.5} xl={2} sx={sxGrid}>
                <Typography sx={sxTypografy}>{(result.unidade1 || '') + '-' + (result.unidade2 || '')}</Typography>
            </Grid>

            <Grid xs={12} sm={12} md={2} lg={2.5} xl={2} sx={sxGrid}>
                <Typography sx={sxTypografy}>{result.origem}</Typography>
            </Grid>

            <Grid xs={12} sm={12} md={1.5} lg={2.5} xl={2.5} sx={sxGrid}>
                <Typography sx={{ ...sxTypografy, ...{ fontSize: '15px' } }}>{result.data_cadastro}</Typography>
            </Grid>

            <Grid xs={12} sm={12} md={1} lg={1} xl={0.5} sx={sxGrid}>
                <Tooltip title='Mais informações' placement='bottom' arrow>
                    <InfoOutlinedIcon sx={{ ...sxTypografy, ...{ cursor: 'pointer' } }} onClick={handleInfo}></InfoOutlinedIcon>
                </Tooltip>
            </Grid>

            {
                openModalConfirmar &&
                <ModalConfirmacaoChegouEntrega
                    open={openModalConfirmar}
                    setOpen={setOpenModalConfirmar}
                    id_encomenda={result.id_encomenda} />
            }

            {
                openModalInfo &&
                <InfoEntrega id_encomenda={result.id_encomenda} setOpoenModalInfo={setOpenModalInfo} openModalInfo={openModalInfo}/>
            }

        </Grid>
    )
}

export default EntregaAguardandoRecebimento
